<template>
  <div class="content-container">
    <!--表格-->
    <div class="table-wrapper">
      <div class="opration-wrapper">
        <a-button @click="inviteUser" type="primary" icon="plus">邀請加入</a-button>
<!--        <a-button @click="handleAdd" type="primary" icon="plus">{{-->
<!--            $t(`actionTitles.create`)-->
<!--          }}</a-button>-->
        <!-- <a-button :style="{marginLeft: '8px'}">{{$t(`message.batchOperate`)}}</a-button> -->
        <a-dropdown placement="bottomCenter">
          <a-menu
              slot="overlay"
              @click="handleChange"
              style="width: 120px; margin-left: 8px"
          >
            <a-menu-item key="delete">{{ $t("actionTitles.delete") }}</a-menu-item>
            <!-- <a-menu-item key="moveTo"> {{$t('message.moveTo')}}</a-menu-item> -->
          </a-menu>
          <a-button style="margin-left: 8px">
            {{ $t("actionTitles.moreOperate") }}
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
      <clear-selected
          alert-type="info"
          :show="selectedRowKeys.length > 0"
          :selectedCount="selectedRowKeys.length"
          @clear="onClearSelected"
      />

      <a-table
          :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
          :data-source="pageResult.data"
          :loading="loading"
          rowKey="id"
          :pagination="pagination"
          @change="handleTableChange"
      >
        <!--帳號-->
        <a-table-column
            key="phone"
            :title="$t('table.user.thead.account')"
            data-index="phone"
        />
        <!--暱稱-->
        <a-table-column
            key="name"
            :title="$t('table.user.thead.nickname')"
            data-index="name"
            align="center"
        />
        <!--全景作品數-->
        <a-table-column
            key="total_works"
            :sorter="true"
            :title="$t('table.user.thead.worksCount')"
            data-index="total_works"
            align="center"
        />
        <!--容量使用-->
        <a-table-column
            key="capacity"
            :sorter="true"
            :title="$t('table.user.thead.storage')"
            data-index="capacity"
            align="center"
        >
          <template slot-scope="text, record">
            <a-progress
                :percent="record.progress"
                :show-info="false"
                status="active"
            />
            <span>{{
                record.use_capacity + "G/" + record.capacity + "G"
              }}</span>
          </template>
        </a-table-column>
        <!--操作按鈕-->
        <a-table-column key="operate" :title="$t('table.common.thead.operate')">
          <template slot-scope="text, record">
            <span>
              <a @click="resetPassword(record.id)">{{
                  $t("login.resetPassword")
                }}</a>
              <a-divider type="vertical" />
              <a @click="detail(record)">{{ $t("actionTitles.detail") }}</a>
              <a-divider type="vertical" />
              <a @click="config(record.id)">{{ $t("actionTitles.config") }}</a>
              <a-divider type="vertical" />
              <a @click="viewWork(record.id)">{{ $t("actionTitles.viewWork") }}</a>
              <a-divider type="vertical" />
              <a-popconfirm
                  placement="top"
                  :ok-text="$t('actionTitles.yes')"
                  :cancel-text="$t('actionTitles.no')"
                  @confirm="handleDelete(record.id)"
              >
                <template slot="title">{{ $t("message.delUser") }}</template>
                <a style="color: red">{{ $t("actionTitles.delete") }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <!--重置密碼-->
    <a-modal
        v-model="updatePasswordModel"
        :title="$t('login.resetPassword')"
        :ok-text="$t('actionTitles.save')"
        :cancel-text="$t('actionTitles.cancel')"
        @ok="updatePassword"
    >
      <a-form-model
          ref="updatePasswordForm"
          layout="vertical"
          :form="updatePasswordForm"
          :rules="passwordRules"
          :model="updatePasswordForm"
      >
        <a-form-model-item
            has-feedback
            :label="$t('form.common.field.password.label')"
            prop="password"
        >
          <a-input-password
              v-model="updatePasswordForm.password"
              :placeholder="$t('form.common.field.password.message')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--編輯彈窗 -->
    <a-modal
        v-model="exitVisible"
        title="邀請用戶"
        :ok-text="$t('actionTitles.save')"
        :cancel-text="$t('actionTitles.cancel')"
        @ok="handleSave"
        width="740px"
    >
      <a-form-model
          ref="ruleForm"
          layout="horizontal"
          :form="form"
          :rules="rules"
          :model="form"
          v-bind="layout"
      >
        <a-form-model-item
            has-feedback
            label="用戶賬號"
            prop="phone"
        >
          <a-input
              v-model="form.phone"
              placeholder="請填寫受邀請人在系統中的賬號"
          />
        </a-form-model-item>
        <a-form-model-item
            has-feedback
            label="昵稱"
            prop="linkman"
        >
          <a-input
              v-model="form.user_team_name"
              placeholder="請輸入在團隊中的姓名"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>


<script>
import ClearSelected from "../../components/ClearSelected";
import {
  pageQuery,
  dealerQueryAll,
  createUser,
  softDelete,
  changeAuthority,
  recommend,
  resetPassword,
} from "@/api/user";
import HRegionSelect from "@/components/HRegionSelect";
import moment from "moment";
import { validatephone } from "@/utils/validate";
import { inviteUser } from "@/api/team"

export default {
  components: { ClearSelected, HRegionSelect },

  data() {
    let phoneCheck = (rule, value, callbackFn) => {
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!validatephone(value)) {
        callbackFn(this.$t("form.common.field.phone.checkMessage"));
        return;
      }
      callbackFn();
    };
    return {
      pid: 0,
      loading: true,
      layout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 },
      },
      searchForm: {},
      expand: false,
      form: {
        phone: "",
        user_team_name:"",
        team_name:""
      },
      pageResult: [],
      selectedRowKeys: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      filters: [
        { text: this.$i18n.t("enum.expireStatus.0"), value: "0" },
        { text: this.$i18n.t("enum.expireStatus.1"), value: "1" },
      ],
      exitVisible: false,
      rules: {
        phone: [
          {
            required: true,
            message: this.$t("form.common.field.phone.message"),
            trigger: "blur",
          },
          { validator: phoneCheck, trigger: "blur" },
        ],
      },
      defaultValue: [],
      dealerList: [],
      passwordRules: {
        password: [
          {
            required: true,
            message: this.$t("form.common.field.password.message"),
            trigger: "blur",
          },
        ],
      },
      updatePasswordModel: false,
      updatePasswordForm: {
        id: 0,
        password: "",
      },
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    },
  },
  updated() {
    console.log("updated");
  },
  mounted() {
    this.pid = this.$route.params?.pid || 0;
    this.searchForm.team_name = localStorage.getItem('clickTeamName') ? localStorage.getItem('clickTeamName') : ''
    this.loadData();
    dealerQueryAll().then((res) => {
      this.dealerList = res.data;
    });
  },
  methods: {
    resetPassword(userId) {
      this.updatePasswordModel = true;
      this.updatePasswordForm = { ...{ id: userId, password: "" } };
      setTimeout(() => {
        this.$refs["updatePasswordForm"].resetFields();
      }, 0);
    },
    updatePassword() {
      this.$refs.updatePasswordForm.validate((valid) => {
        if (valid) {
          resetPassword(this.updatePasswordForm).then((res) => {
            this.$message.success(this.$t("message.saveSuccess"));
            this.updatePasswordModel = false;
          });
        }
      });
    },
    recommend(record) {
      let userType = this.$store.getters.userInfo.type;
      if (userType == 1) {
        let userInfo = { id: record.id };
        userInfo.recommend = record.recommend == 1 ? 0 : 1;
        recommend(userInfo).then((res) => {
          this.loadData();
        });
      }
    },
    authorityChange(record) {
      let is_authority = record.is_authority == 1 ? 0 : 1;
      changeAuthority({ id: record.id, is_authority: is_authority }).then(
          (res) => {
            this.loadData();
          }
      );
    },
    onSearch() {
      this.pagination.current = 1;
      this.loadData();
    },
    //數據加載
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
          pid: this.pid,
        },
      };
      pageQuery(this.searchParam)
          .then((res) => {
            this.loading = false;
            this.pageResult = res.data;
            this.pagination.total = res.data.total;
          })
          .catch((err) => {
            this.loading = false;
          });
    },
    //table 翻頁
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";

        let order = {};
        order[field] = orderStr;
        this.searchForm.order = order;
      }
      this.loadData();
    },
    handleAdd() {
      this.exitVisible = true;
      setTimeout(() => {
        this.exitModelRest();
      }, 0);
    },
    handleSave() {
      console.log(this.form);
      this.form.team_name = localStorage.getItem('clickTeamName');
      inviteUser(this.form).then((res) => {
        this.loadData();
        this.$message.success(this.$t("message.saveSuccess"));
        this.exitVisible = false;
      });
    },
    handleDelete(id) {
      let ids = [id];
      this.delete(ids);
    },
    delete(ids) {
      softDelete({ id: ids }).then((res) => {
        this.loadData();
        this.$message.success(this.$t("message.deleteSuccess"));
      });
    },
    handleChange(val) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$i18n.t("message.selectHint"));
        return;
      }
      if (val.key == "delete") {
        this.delete(this.selectedRowKeys);
      }
    },
    detail(record) {
      this.$router.push({
        path: "/agent/manager/detail",
        query: { userId: record.id },
      });
    },
    config(userId) {
      this.$router.push({
        path: "/agent/manager/config",
        query: { userId },
      });
    },
    handleReset() {
      this.searchForm = {};
      this.pagination.current = 1;
      this.loadData();
    },
    exitModelRest() {
      this.form = {
        gender: 1,
        g_capacity: 20,
        expire_time: moment().add(1, "year"),
      };
      this.$refs["ruleForm"].resetFields();
    },
    selectedData(val) {
      this.form.region = val;
    },
    toggle() {
      this.expand = !this.expand;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
    },
    viewWork(uid) {
      this.$router.push({ path: "/agent/workManage/workList", query: { uid } });
    },
    inviteUser(){
      this.exitVisible = true;
      setTimeout(() => {
        this.exitModelRest();
      }, 0);
    }
  },
};
</script>

<style lang="less" scoped>
</style>
